export const PRODUCT_MAP = {
  THIS_PRODUCT: 'THIS_PRODUCT',
  OTHER_PRODUCTS: 'OTHER_PRODUCTS'
}
